// extracted by mini-css-extract-plugin
export default {"input":"styles__input___ok3ZI","link":"styles__link___r-zxo"};